import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

const useIsBinderDisabled = (isDisabled: boolean = false) => {
  return useFormBinderDisabled('autoPersonalForm', isDisabled);
};

export default useIsBinderDisabled;
